<div class="header-container d-print-none d-print-none">
    <div class="logo-container">
        <a (click)="toggleSidebar()" href="/" class="sidebar-toggle">
            <nb-icon icon="menu-2-outline"></nb-icon>
        </a>
        <a class="logo-anchor" href="/" (click)="navigateHome()">
            <ng-container *ngIf="currentTheme === 'corporate' || currentTheme === 'default'">
                <img class="logo" src="../../../../assets/logo_dark.svg" alt="Favrit logo" />
            </ng-container>
            <ng-container *ngIf="currentTheme === 'dark' || currentTheme === 'cosmic'">
                <img class="logo" src="../../../../assets/logo_light.svg" alt="Favrit logo" />
            </ng-container>
        </a>
    </div>
    <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
        <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select>
</div>

<div class="header-container">
    <nb-actions size="small">
        <nb-action *ngIf="location?.publicId && showLocationSpecificHeaderFeatures">
            <div class="app-link">
                <nb-icon icon="external-link-outline"></nb-icon>
                <a class="open-app-link" href="{{ appHost }}/menu/location/{{ location?.publicId }}" target="_blank">
                    Open app</a
                >
            </div>
        </nb-action>
        <nb-action *ngIf="location?.publicId && showLocationSpecificHeaderFeatures && eposFeature?.active">
            <div class="app-link">
                <nb-icon icon="external-link-outline"></nb-icon>
                <a class="open-app-link" href="{{ eposUrl }}/{{ location?.publicId }}" target="_blank">
                    Open ePOS app</a
                >
            </div>
        </nb-action>

        <nb-action *ngIf="location && showLocationSpecificHeaderFeatures" (click)="goToOpeningHours()" class="status">
            <div class="mr-10">Status</div>
            <div class="tag" (click)="goToOpeningHours()" *ngIf="location.state === 'OPEN'">{{ location.state }}</div>
            <div class="tag danger" (click)="goToOpeningHours()" *ngIf="location.state !== 'OPEN'">
                {{ location.state }}
            </div>
            <!-- <nb-search type="rotate-layout"></nb-search> -->
        </nb-action>
        <nb-action class="user-action" *ngIf="locationMenu && location && showLocationSpecificHeaderFeatures">
            <nb-user
                *nbIsGranted="['view', 'user']"
                [nbContextMenu]="locationMenu"
                [onlyPicture]="userPictureOnly"
                [name]="location.name"
            >
            </nb-user>
        </nb-action>
        <nb-action class="user-action" *ngIf="userMenu && authenticatedUser">
            <nb-user
                *nbIsGranted="['view', 'user']"
                [nbContextMenu]="userMenu"
                picture="assets/images/user_icon.svg"
                [onlyPicture]="userPictureOnly"
                [name]="authenticatedUser.userName"
            >
            </nb-user>
        </nb-action>
    </nb-actions>
</div>
